import config from "config/config";
import { SaveCustomerPayload } from "helpers/WizardHelper";
import { MyCustomer } from "models/customers/customers";
import { apiRequest } from "./apiInterceptor";

export class CustomersAPI {
  static async searchForCustomers(searchTerm: string): Promise<MyCustomer[]> {
    const response = await apiRequest
      .get(config.api.customer.findAllCustomers)
      .query({
        Find: searchTerm
      });
    const result: MyCustomer[] = response.body;
    return result;
  }

  static async closeCustomer(customerId: string) {
    return new Promise((resolve, reject) => {
      apiRequest
        .put(config.api.customer.close(customerId))
        .end((err, res) => {
          err ? reject({ err, res }) : resolve(res);
        });
    });
  }

  static async getCustomersInternal(): Promise<MyCustomer[]> {
    const response = await apiRequest
      .get(config.api.user.customers)
      .send();
    const result: MyCustomer[] = response.body.items;
    return result;
  }

  static async getCustomerSettings(id: string) {
    const response = await apiRequest
      .get(config.api.customer.get(id))
      .send();
    return response.body;
  }

  static async saveCustomer(customerPayload: SaveCustomerPayload) {
    return await apiRequest
      .post(config.api.customer.save)
      .send(customerPayload);
  }
}
